<div class="animated fadeInRight">
  <!-- MENU DE TITULOS -->
  <app-lfsa-card-v2 [innTemplateButton]="innTemplateButton" [innTemplate]="enviarTemplateEdit"
                    [modulo]="DAT_TITULOS.modulo" [tituloCard]="DAT_TITULOS.tituloCardListar"
                    [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <!-- MENU DE TITULOS -->

  <!-- OPCIONES LATERAL IZQUIERDO -->
  <ng-template #innTemplateButton>
    <div class="col-md-6 mb-2">
      <div class="pagetitle">
        <div class="btn-group-justified btn-group" style="float: right;">
          <button (click)="nueva()" class="btn btn-outline-success">
            <i aria-hidden="true" class="fa fa-plus"></i>
            {{DAT_BTNS.agregar}}
          </button>
        </div>
      </div>
    </div>
  </ng-template>
  <!-- OPCIONES LATERAL IZQUIERDO -->

  <!-- GRILLA -->
  <ng-template #enviarTemplateEdit>
    <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
    <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" [class]="DAT_AG_GRID.class" [columnDefs]="columnDefs"
                     [floatingFilter]="true" [frameworkComponents]="frameworkComponents" [id]="DAT_AG_GRID.id"
                     [ngStyle]="DAT_AG_GRID.style" [paginationPageSize]="DAT_AG_GRID.paginacion"
                     [pagination]="true"
                     [rowData]="rowData">
      [rowSelection]="'single'"
    </ag-grid-angular>
  </ng-template>
  <!-- GRILLA -->
</div>

<!-- MODAL -->
<app-lfsa-modal [classModal]="'modal-lg'" [idButton]="'abrirModal'" [idClose]="'cerrarModal'" [innTemplate]="abrirModal"
                [titulo]="tituloModal"></app-lfsa-modal>
<ng-template #abrirModal>
  <div class="container-fluid">
    <form [formGroup]="formBascula" class="row" mat-dialog-content>
      <div *ngIf="!isCreate" class="col-lg-5 mb-2">
        <label>Id</label>
        <input class="form-control" formControlName="idBascula" name="id" type="text" readonly>
      </div>
      <div class="col-lg-7 mb-2">
        <label>IP Balanza</label>
        <input (change)="duplicatedIP();validForm()" (keyup)="duplicatedIP();validForm()" class="form-control"
               formControlName="ipBalanza"
               name="ipBalanza" type="text">
        <div
          *ngIf="validIP || (formBascula.controls['ipBalanza'].invalid && (formBascula.controls['ipBalanza'].dirty || formBascula.controls['ipBalanza'].touched))"
          class="text-danger">
          <small>
            <div *ngIf="formBascula.controls['ipBalanza'].errors">
              Formato inválido.
            </div>
            <div *ngIf="validIP && !formBascula.controls['ipBalanza'].errors">
              Esta IP ya se encuentra registrada, no se pernmite duplicar las direcciones IP.
            </div>
          </small>
        </div>
      </div>
      <div class="col-lg-12 mb-2">
        <label>Descripción</label>
        <input (change)="validForm()" (keyup)="validForm()" class="form-control" formControlName="desca"
               name="desca"
               type="text">
        <div
          *ngIf="formBascula.controls['desca'].invalid && (formBascula.controls['desca'].dirty || formBascula.controls['desca'].touched)"
          class="text-danger">
          <small>
            <div *ngIf="formBascula.controls['desca']?.hasError('required')">
              Este campo es requerido.
            </div>
            <div *ngIf="formBascula.controls['desca']?.hasError('maxlength')">
              Máximo 30 caracteres
            </div>
          </small>
        </div>
      </div>
      <div class="col-lg-6 mb-3">
        <label>Estado</label>
        <select (change)="validForm()" class="form-control" formControlName="estado" name="estado">
          <option value="">-- Seleccione --</option>
          <option value="0">Activo</option>
          <option value="1">Inactivo</option>
        </select>
        <div
          *ngIf="formBascula.controls['estado'].invalid && (formBascula.controls['estado'].dirty || formBascula.controls['estado'].touched)"
          class="text-danger">
          <small>
            <div *ngIf="formBascula.controls['estado'].errors">
              Este campo es requerido.
            </div>
          </small>
        </div>
      </div>
      <div class="col-lg-6 mb-3">
        <label>Centro</label>
        <select (change)="validForm()" class="form-control" formControlName="centros" name="centros">
          <option value="">-- Seleccione --</option>
          <option *ngFor="let cmb of cmbCentros" value="{{cmb.idCentro}}">{{cmb.nombreCentro}}</option>
        </select>
        <div
          *ngIf="formBascula.controls['centros'].invalid && (formBascula.controls['centros'].dirty || formBascula.controls['centros'].touched)"
          class="text-danger">
          <small>
            <div *ngIf="formBascula.controls['centros'].errors">
              Este campo es requerido.
        </div>
          </small>
        </div>
      </div>

      <div class="row">
        <div class="alert alert-secondary d-flex justify-content-between" role="alert">
          <div>Espacio reservado para integracion de equipos, sensores y marquesinas (Only Control)</div>
        </div>
        <div class="col-md-6">
          <app-lfsa-input formControlName="sensorId" [label]="'Id Sensor Only Control'" [id]="'sensorId'" [control]="formBascula.get('sensorId')"
           class="form-control-sm" [type]="'text'" class="form-control-sm" >
          </app-lfsa-input>
        </div>
      </div>

      <app-lfsa-botones-formulario (devolverAccion)="acciones( $event )" [formularioValido]="validForm()"
                                   [loading]="loading" [textBoton]="'Guardar'" class="row">
      </app-lfsa-botones-formulario>
    </form>
  </div>
</ng-template>
<!-- END MODAL -->
